import React, { useEffect, useState, useContext } from 'react';
import StepWizard from "react-step-wizard";
import WizardCheckListStep from './WizardCheckListStep';
import WizardCheckListStepAgrupado from './WizardCheckListStepAgrupado';
import WizardCheckListStepCanPos from './WizardCheckListStepCanPos';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';

import axios from 'axios';

import { LoginContext } from '../../../hooks/context/LoginContext';

import Cookies from 'universal-cookie';
import { Fragment } from 'react';
import { Spinner } from 'react-bootstrap';
import ButtonOutline from '../../ui/ButtonOutline';
import Informes from '../informes/Informes';
import WizardBtns from '../WizardBtns';

import { getIndexUrl, getApiUrl, axiosPost } from '../../../helpers/helperApp';

function WizardCheckList(props){

    const cookies = new Cookies();
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    const { titulo, cabecera, registrosHijo, controles, estadoForm, adjuntos, adjuntosExistentes, confPantalla, saveLoadReg, propiedades, adjuntosCabecera, informeSelect, informeLoadReg, informeEstadoForm, informeTraduction, loadedHijos } = props;

    const { apiKey, menuMode, btnWizPos } = useContext(LoginContext);

    const [ lineas, saveLineas ] = useState([]);
    const [ currentStep, saveCurrentStep] = useState(0);
    const [ regAnterior, saveRegAnterior ] = useState();
    const [ loadedSteps, saveLoadedSteps ] = useState(false);
    const [ loadingForms, saveLoadingForms ] = useState(true);
    const [ trabajoSinLineas, saveTrabajoSinLineas ] = useState(false); 
    const [ lineaSoloHerramientas, saveLineaSoloHerramientas ] = useState([]);
    const [ lineasAgrupadas, saveLineasAgrupadas ] = useState([]);
    const [ nomEquipo, saveNomEquipo ] = useState("");
    const [ loadedHijosState, saveLoadedHijosState ] = useState(loadedHijos);
    const [ lineasAgrupadasCanPos, saveLineasAgrupadasCanPos ] = useState([]);
    const [ lineasFirmas, saveLineasFirmas ] = useState([]);
           
    useEffect( () => { 

        // Cargamos la configuración de todas las líneas y guardamos las que no sean herramientas en el state para pasarle al stepwizard
        init(registrosHijo); 
        
        return () =>{    
            // Token cancelación axios al desmontar componentes
            source.cancel();
        } 

    },[registrosHijo])

    // Preparamos los adjuntos de la cabecera para el datatable    
    adjuntosCabecera.map(adj => {
        let ruta = getApiUrl(window.location.origin)+adj.rut;
        let downLoad = `download=${ruta}`;
        if((adj.rut.includes('http') || adj.rut.includes('https') || adj.rut.includes('www')) && !adj.rut.includes('.api.')){
            ruta = adj.rut;
            downLoad = '';
        }
        adj["html"] = `<a 
                        href='${ruta}'
                        target='_blank'
                        class='btn btn-success'
                        style='color: white !important'
                        ${downLoad}
                        >
                            <i 
                                class='fal fa-download'
                                data-rut=${ruta}
                                style='margin-right:5'
                            >
                            </i>
                        </a>
                        ${adj.des}
                    `; 

    })  
    
    const init = async (registrosHijo) => {

        await loadConfWizard(registrosHijo)

    }


    const loadConfWizard = async(registrosHijo) => {

        const data = new FormData();
        data.append("validacion", apiKey());

        let regsIdUniIdTip = []
        registrosHijo.map( reg => {
            let aux = { idreg : reg.id, iduni : reg.iduni, idtip : reg.tipuni }
            regsIdUniIdTip.push(aux);
        } )

        data.append("getconf", JSON.stringify(regsIdUniIdTip));
        // const respuesta = await axios.post(getApiUrl(window.location.origin)+controles.wizardchecklist.getconfuni, data);
        const respuesta = await axiosPost(getApiUrl(window.location.origin)+controles.wizardchecklist.getconfuni, data, source.token);
       
        let todasLineasSinConfiguracion = true;
        let materialInsertado = false;
        let canPosInsertado = false;
        let auxLineasSinAgrupar = [];
        let auxLineasFirmas = [];
        if( Object.keys(respuesta.data).length > 0 ){
            for( let i=0; i<Object.keys(respuesta.data).length; i++ ){
                for (const [key, configuracionLinea] of Object.entries(respuesta.data[i])) {
                    let agrupado = false;
                    let lineaCanPos = false;
                    let esFirma = false;

                    // Filtro el registro que estoy iterando
                    const registro = registrosHijo.filter( reg => reg.id == key )[0];

                    // Guardamos el nombre del equipo en el state
                    saveNomEquipo(registro.equipo);                    

                    if( configuracionLinea ){
                        todasLineasSinConfiguracion = false;
                        configuracionLinea.split(";").map((e) => {
                            if( e == 21 || e == "21R" || e == "R21" || e == "21SL" || e == "SL21"){                                
                                agrupado=true; 
                            }
                            if( e == 22 || e == "22R" || e == "R22" || e == "22SL" || e == "SL22"){                                 
                                lineaCanPos = true;
                                agrupado=true; 
                            }
                            if( e == 7 || e == "7R" || e == "R7" || e == "7SL" || e == "SL7"){                                 
                                let data = [];
                                data[0] = {val : configuracionLinea};
                                let aux = {
                                    "linea"     : registro,
                                    "respuesta" : {data : data}
                                }
                                auxLineasFirmas.push(aux);
                                saveLineasFirmas(auxLineasFirmas);
                                esFirma = true;
                            }                                    
                        })
                        // Almacenamos en el state que pasamos al stepwizar las lineas que no están agrupadas
                        if( !agrupado && !esFirma ){
                            let data = [];
                            data[0] = {val : configuracionLinea};
                            let aux = {
                                "linea"     : registro,
                                "respuesta" : {data : data}
                            }
                            saveLineas(lineas => [...lineas, aux]);
                            auxLineasSinAgrupar.push(aux);
                        }
                        // Almacenamos en el state de lineas agrupadas para crear un único paso para ellos
                        if( lineaCanPos ){
                            let data = [];
                            data[0] = {val : configuracionLinea};
                            let aux = {
                                "linea"     : registro,
                                "respuesta" : {data : data}
                            }
                            saveLineasAgrupadasCanPos(lineasAgrupadasCanPos => [...lineasAgrupadasCanPos, aux]);
                            if( !canPosInsertado ){
                                canPosInsertado = true;
                                // Guardarla en la primera posición para que coincida con el index en el map return ya que sino en la ultima linea muestra una que no es
                                let auxConPos = [];
                                auxConPos.push(aux);
                                for( let i=0; i<auxLineasSinAgrupar.length; i++ ){
                                    auxConPos.push(auxLineasSinAgrupar[i]);
                                }
                                saveLineas(auxConPos);
                            }                               
                        } 
                        // Almacenamos en el state de lineas agrupadas para crear un único paso para ellos
                        if( agrupado && !lineaCanPos ){
                            let data = [];
                            data[0] = {val : configuracionLinea};
                            let aux = {
                                "linea"     : registro,
                                "respuesta" : {data : data}
                            }
                            saveLineasAgrupadas(lineasAgrupadas => [...lineasAgrupadas, aux]);
                            if( !materialInsertado ){
                                materialInsertado = true;
                                let auxLineaMat = [];
                                auxLineaMat.push(aux);
                                for( let i=0; i<auxLineasSinAgrupar.length; i++ ){
                                    auxLineaMat.push(auxLineasSinAgrupar[i]);
                                }
                                saveLineas(auxLineaMat);
                            }                               
                        }                           
                    }
    
                }
            }
            
            // Modificación corrección mensaje trabajo no disponble mientras no llegan las lineas
            saveTrabajoSinLineas(false);
            if( todasLineasSinConfiguracion ){
                saveTrabajoSinLineas(true);
            }
            
        }else if( respuesta.data.length == 0 ){
            // Si i es igual a 0 no hay lineas
            saveTrabajoSinLineas(true);
            saveLoadedSteps(true);
        }
        
        saveLoadedSteps(true);

    }

    const steps = []
    for (let i = 1 ; i <= lineas.length; i++) {        
            steps.push(
                <Step>
                    <StepLabel></StepLabel>
                </Step>
            )
    }

    const noLinesNext = () => {
        propiedades.history.push(getIndexUrl(menuMode, "wizardchecklist"));
    } 

    return(
        <div>
            {
                lineas.length > 0 && loadedSteps 
                ?
                <Fragment>
                    <Informes
                        select =     { informeSelect }
                        formulario = { cabecera }
                        loadReg =    { informeLoadReg ? true : false }
                        estadoForm=  { informeEstadoForm } 
                        traduction=  { informeTraduction }
                    />   
                    <div className="row">
                        <hr data-content={currentStep+1+"/"+lineas.length} className="hr-text-xl"></hr>
                    </div>
                    <div className="row" style={{overflowY: "auto"}}>
                        <div className="col-md-12 stepsContainer">
                            <Stepper activeStep={currentStep}>
                                {steps}                      
                            </Stepper>
                        </div>
                    </div>
                    
                    <StepWizard>
                        {
                            lineas.map((linea, index, lineas) => {                                
                                
                                if( index == 0 && lineasAgrupadasCanPos.length > 0 ){
                                    return(
                                        <WizardCheckListStepCanPos
                                            key={ index }
                                            lineasCanPos={ lineasAgrupadasCanPos }
                                            cabecera={ cabecera }
                                            paso={ index+1 }
                                            pasos={ lineas.length }
                                            saveCurrentStep={ saveCurrentStep }
                                            controles={ controles } 
                                            confPantalla={ confPantalla }
                                            saveLoadReg={ saveLoadReg }
                                            propiedades={ propiedades }
                                            saveRegAnterior={ saveRegAnterior }
                                            loadingForms={ loadingForms }
                                            saveLoadingForms={ saveLoadingForms }
                                            soloHerramientas={ false }
                                            adjuntosCabecera={ adjuntosCabecera }
                                            updateCanPos={ controles.wizardchecklist.updateagrupados } 
                                            nomEquipo={ nomEquipo }
                                            lineasFirmas={ lineasFirmas }
                                        />
                                    )
                                }else if( (index == 1 && lineasAgrupadas.length > 0 && lineasAgrupadasCanPos.length > 0 ) || (index == 0 && lineasAgrupadas.length > 0 && lineasAgrupadasCanPos.length == 0 ) ){
                                    return(
                                        <WizardCheckListStepAgrupado
                                            key={ index }
                                            lineasAgrupadas={ lineasAgrupadas }
                                            saveLineasAgrupadas={ saveLineasAgrupadas }                                            
                                            cabecera={ cabecera }
                                            paso={ index+1 }
                                            pasos={ lineas.length }
                                            saveCurrentStep={ saveCurrentStep }
                                            controles={ controles } 
                                            estadoForm={ estadoForm }
                                            confPantalla={ confPantalla }
                                            saveLoadReg={ saveLoadReg }
                                            propiedades={ propiedades }
                                            saveRegAnterior={ saveRegAnterior }
                                            loadingForms={ loadingForms }
                                            saveLoadingForms={ saveLoadingForms }
                                            adjuntosCabecera={ adjuntosCabecera }
                                            updateagrupados={ controles.wizardchecklist.updateagrupados } 
                                            nomEquipo={ nomEquipo }
                                            lineasFirmas={ lineasFirmas }
                                        />
                                    )
                                }else{
                                    return(                                    
                                        <WizardCheckListStep                                    
                                            key={ index }
                                            cabecera={ cabecera }
                                            paso={  index+1  }
                                            pasos={ lineas.length }
                                            linea={ linea.linea }
                                            respuesta={ linea.respuesta }
                                            saveCurrentStep={ saveCurrentStep }
                                            controles={ controles } 
                                            estadoForm={ estadoForm }
                                            adjuntos={ adjuntos }
                                            adjuntosExistentes={ adjuntosExistentes }
                                            confPantalla={ confPantalla }
                                            saveLoadReg={ saveLoadReg }
                                            propiedades={ propiedades }
                                            regAnterior={ regAnterior }
                                            saveRegAnterior={ saveRegAnterior }
                                            loadingForms={ loadingForms }
                                            saveLoadingForms={ saveLoadingForms }
                                            adjuntosCabecera={ adjuntosCabecera }
                                            nomEquipo={ nomEquipo }
                                            lineasFirmas={ lineasFirmas }
                                        />
                                    )
                                }                             
                            })
                        }                
                    </StepWizard>                    
                </Fragment>                
                :
                    trabajoSinLineas && loadedSteps && loadedHijosState
                    ?
                        <Fragment>
                            <h1 className="text-center">{controles.wizardchecklist.nolines.title}</h1>                         
                            {
                                btnWizPos == "bottom" || btnWizPos == "both" 
                                ?
                                    <WizardBtns 
                                        accionBtnExit={noLinesNext}
                                        accionBtnPrev={null}
                                        accionBtnNext={noLinesNext}
                                        disabledBtnExit={false}
                                        disabledBtnPrev={null}
                                        disabledBtnNext={false}
                                    />
                                :
                                    null
                            }
                        </Fragment>
                    : 
                        <div className="text-center">
                            <Spinner animation="border" />
                        </div>
            }
        </div>
    )
}

export default WizardCheckList;